import React from 'react'

import { AccordionLinkGroup } from '~/components/features/AccordionLinkGroup'
import { AccordionNavigation } from '~/components/features/AccordionNavigation'
import { type NavigationContentProps } from '~/utils'

import { useNavigationGroups } from './hooks/useNavigationGroups'

export const NavigationContent = ({
  isExpanded = false,
  onToggle,
}: NavigationContentProps) => {
  const groups = useNavigationGroups()

  return (
    <AccordionNavigation
      groups={groups}
      isExpanded={isExpanded}
      onToggle={onToggle}
    >
      {({ groupMap }) => <AccordionLinkGroup group={groupMap.settings} />}
    </AccordionNavigation>
  )
}
